import { Input, message } from 'antd';
import { Modal } from 'antd';
import React, { useState } from 'react'
import { updateRoute } from '../../../../../Utils/SupabaseServices/StayUpToDateDatabase';

function EditRouteModal(props: any) {
  const {
    showRouteModal,
    closeRouteModal,
    username,
    route,
    setRoute,
    routeError,
    setRouteError,
    from,
    refetch,
    routeEditComponent,
    user_id
  } = props;

  const [saving, setSaving] = useState(false);
const [error,setError] = useState<any>("")
  const saveRoute = async () => {
    const validRoute = /^[a-zA-Z0-9]{1,15}$/;
    if (!validRoute.test(route)) {
      setRouteError("Enter a valid route");
      return;
    }
    setSaving(true);
    const result = await updateRoute(routeEditComponent, route, from,user_id);
    setSaving(false);
    if (!result.success) {
      // message.error(result.error);
      setError(result.error);
      return;
    }
    closeRouteModal();
    refetch(); // Refresh the data
  };

  return (
    <Modal
        open={showRouteModal}
        onCancel={closeRouteModal}
        onOk={saveRoute}
        confirmLoading={saving}
        getContainer={false}
        okText="Save"
        cancelText="Cancel"
        title="Customize Your Link"
        centered
      >
        <div style={{ display: 'flex', gap: 4, flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}>
            <span style={{ color: '#888', fontSize: 14 }}>www.searchbubble.com/{username}/</span>
            <Input
              value={route}
              onChange={e => {
                const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 15);
                setRoute(val.toLowerCase());
                setRouteError(""); // Clear error on input
              }}
              placeholder={route}
              style={{ flex: 1 }}
            />
          </div>
          <span style={{ fontSize: 10, color: '#888', marginTop: 4, width: '100%', textAlign: 'center' }}>
            Your custom ending can include only small letters and numbers, up to 15 characters.
          </span>
        </div>
        {routeError && <span style={{ color: 'red', fontSize: 12 }}>{routeError}</span>}
        {error && <span style={{ color: 'red', fontSize: 12 }}>{error}</span>}
      </Modal>
  )
}

export default EditRouteModal